import { LOGO, SELLER_LOGIN_URL } from "../utils/Constants";
import { Link } from "react-router-dom";

function WelcomeMessage({ username, password }) {
  return (
    <div className="col-md-8 m-auto mt-20">
      <div className="reg-card text-center py-10 px-20">
        <div className="m-auto">
          <img
            src={LOGO}
            alt="Indian MSME Logo"
            className="text-center inline"
            width={150}
          />
        </div>
        <h2 className="text-2xl font-bold mb-2">Congratulations 🎉</h2>
        <p className="text-xl font-bold mb-2">Welcome to IndianMSME</p>
        <p className="text-lg mb-4">
          Thank you for choosing to be a part of IndianMSME. Your registration
          is complete, and we're excited to have you on board. Get ready to
          explore, connect, and enjoy all the benefits of being a member. If you
          have any questions or need assistance, feel free to reach out.
        </p>
        <p className="text-xl font-bold mb-4">
          Helpline Number:- +91-8800001242, +91-9990060509
        </p>

        <div className="mt-6">
          <Link
            to={SELLER_LOGIN_URL}
            className="btn btn-success"
            target={"_blank"}
          >
            👉 Click Here to Login
          </Link>
        </div>

        <div className=" p-4 rounded-md inline-block text-left">
          <p className="text-lg font-bold">
            Username: <span className="text-gray-700">{username}</span>
          </p>
          <p className="text-lg font-bold">
            Password: <span className="text-gray-700">{password}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default WelcomeMessage;
